import { DataTable, FormLabel, Heading, Loader, Select } from "@/components";
import { Button, Input } from "@/components/ui";
import { Search } from "lucide-react";
import useDocumentTypeConfig from "./useDocumentTypeConfig";

const DocumentTypeConfig = () => {
  const {
    breadcrumbData,
    isMobile,
    globalFilter,
    setGlobalFilter,
    onAdd,
    docTypes,
    isDocTypeLoading,
    columns,
    onRowClick,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    hasAddPermission,
    isMasterDataRoute,
    communityList,
    isCommunityLoading,
    communityId,
    onCommunityChange,
    communityKey,
  } = useDocumentTypeConfig();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Document Types" breadcrumbData={breadcrumbData} />
          {isMobile &&
            hasAddPermission && (
              <Button onClick={onAdd} className="px-2">
                + Add Document Type
              </Button>
            )}
        </div>
        <div className="flex flex-col md:flex-row md:items-center gap-4 mt-4 md:mt-auto">
          {isMasterDataRoute && (
            <div className="relative w-full md:w-[150px]">
              <FormLabel>Select Community</FormLabel>
              <Select
                key={communityKey}
                placeholder="Please select"
                noDataPlaceholder={"Community No Found"}
                options={communityList?.data?.map((data: any) => ({
                  value: data?.communityId,
                  label: data?.name,
                }))}
                value={communityId}
                onChange={onCommunityChange}
                className="h-[36px]"
                disabled={isCommunityLoading}
              />
            </div>
          )}
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile &&
            hasAddPermission && <Button onClick={onAdd}>+ Add Document Type</Button>}
        </div>
      </div>

      {/* Responsive Table */}
      {isDocTypeLoading ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={[...(docTypes?.data || [])]
              .sort((a, b) => {
                return a.communityId - b.communityId;
              })
              .reverse()}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(docTypes?.total / pageSize)}
            totalRecords={docTypes?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default DocumentTypeConfig;
